export default __webpack_public_path__ + "static/media/clinica_big.9969abe4.png";